import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { CalendarPlus, PartyPopper, CheckCircle } from "lucide-react";
import ProposeEventDialog from "../components/ProposeEventDialog";
import { toast } from "sonner";

export default function ProposerEvenementPage() {
  const [showDialog, setShowDialog] = useState(false);
  const [eventProposed, setEventProposed] = useState(false);
  const token = localStorage.getItem("token");

  const handleEventProposed = (event) => {
    setEventProposed(true);
    toast.success("Votre événement a été proposé avec succès !");
    setShowDialog(false);
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <div className="mb-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
          <PartyPopper className="w-8 h-8 text-primary" />
        </div>
        <h1 className="text-3xl font-bold mb-2">Proposer un événement</h1>
        <p className="text-muted-foreground">
          Vous avez une opportunité d'événement ? Proposez-le à Food Truck United !
        </p>
      </div>

      {eventProposed ? (
        <Card className="border-green-200 bg-green-50">
          <CardContent className="pt-6 text-center">
            <CheckCircle className="w-12 h-12 text-green-600 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-green-800 mb-2">
              Événement proposé !
            </h2>
            <p className="text-green-700 mb-4">
              Votre proposition a été envoyée. L'équipe Food Truck United l'examinera prochainement.
            </p>
            <Button 
              variant="outline" 
              onClick={() => setEventProposed(false)}
              className="border-green-300 text-green-700 hover:bg-green-100"
            >
              Proposer un autre événement
            </Button>
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <CalendarPlus className="w-5 h-5 text-primary" />
              Nouveau événement
            </CardTitle>
            <CardDescription>
              Remplissez le formulaire pour proposer un événement
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h3 className="font-medium text-blue-800 mb-2">Comment ça marche ?</h3>
              <ul className="text-sm text-blue-700 space-y-1">
                <li>1. Cliquez sur "Proposer un événement"</li>
                <li>2. Remplissez les informations de l'événement</li>
                <li>3. L'équipe Food Truck United validera votre proposition</li>
                <li>4. Vous serez notifié de la décision</li>
              </ul>
            </div>

            <Button 
              size="lg" 
              className="w-full"
              onClick={() => setShowDialog(true)}
            >
              <CalendarPlus className="w-5 h-5 mr-2" />
              Proposer un événement
            </Button>
          </CardContent>
        </Card>
      )}

      <ProposeEventDialog
        isOpen={showDialog}
        onOpenChange={setShowDialog}
        token={token}
        onEventProposed={handleEventProposed}
      />
    </div>
  );
}
